import { Prefs } from "~/alias/prefs";
export async function getBlockCount() {
    await Prefs.untilLoaded;
    return Prefs.get("blocked_total");
}
